import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
import { EntitySuggestionSchema, SystemSuggestionPayloadSchema, OrgFunctionSuggestionPayloadSchema } from '../../entities/entity-suggestion';
/**
 * Create-suggestion request shape.
 *
 * Suggestions carry no `location` — the caller writes the returned suggestion
 * `_id` directly into the slot they're filling (`{ type: 'suggestion', id }`).
 *
 * Origin: `sourceRecordingId` is the source NODE's id — a step recording, or
 * the start event node the start-event picker sends since the issue-11
 * anchor unification.
 */ const CreateSystemSuggestionInput = z.object({
    kind: z.literal('system'),
    sourceRecordingId: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    payload: SystemSuggestionPayloadSchema
});
const CreateOrgFunctionSuggestionInput = z.object({
    kind: z.literal('orgFunction'),
    sourceRecordingId: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    payload: OrgFunctionSuggestionPayloadSchema
});
export const CreateEntitySuggestionRequestSchema = z.discriminatedUnion('kind', [
    CreateSystemSuggestionInput,
    CreateOrgFunctionSuggestionInput
]);
export const CreateEntitySuggestionResponseSchema = z.object({
    data: EntitySuggestionSchema
});

//# sourceMappingURL=create-entity-suggestion.contract.js.map